import { render, staticRenderFns } from "./VProductItem.vue?vue&type=template&id=6c8b9df0&scoped=true&"
import script from "./VProductItem.vue?vue&type=script&lang=ts&"
export * from "./VProductItem.vue?vue&type=script&lang=ts&"
import style0 from "./VProductItem.vue?vue&type=style&index=0&id=6c8b9df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b9df0",
  null
  
)

export default component.exports